import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

export const startBugsnag = () => {
    if (Bugsnag.isStarted()) return;

    Bugsnag.start({
        apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "test-api-bugsnag-key",
        plugins: [new BugsnagPluginReact()],
        releaseStage: process.env.NODE_ENV,
        appVersion: process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0",
    });

    BugsnagPerformance.start({
        apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "test-api-bugsnag-key",
    });
};

export const getErrorBoundary = () => {
    return Bugsnag.getPlugin("react")!.createErrorBoundary(React);
};
